import { useTimedOut } from '@aboutyou/legacy-shared/src/utils/hooks/useManualTimeout'
import { useDisplayBrowserState } from 'helpers/hooks/useDisplayBrowserState'
import { useIsScrollingDown } from 'helpers/hooks/useIsScrolling'
import React from 'react'
import { Sticky } from 'react-stickup-ay'
import styled from 'styled-components'
import CategorySortingBar from './CategorySortingBar'

const StyledSticky = styled(Sticky)`
  z-index: 2;
  width: 100% !important;
`

const StickyWrapper = styled.div`
  background: #fff;
  transition: transform 200ms;
`

const hiddenSortingStyles = {
  transform: 'translateY(65px)',
}

interface Props {
  title?: string
  subHeader?: React.ReactNode
  stickyOffsetTop?: number
}

const ProductStreamHeader: React.FC<Props> = ({
  title,
  subHeader = null,
  stickyOffsetTop = 0,
}) => {
  const isScrollingDown = useIsScrollingDown()
  const isScrollingUp = !isScrollingDown
  const hydrationDone = useDisplayBrowserState()
  const timedOut = useTimedOut(3000) // rendering the sticky component after hydration breaks the hydration. So we wait 3 seconds before rendering it to avoid this issue

  if (!hydrationDone || !timedOut) {
    return <CategorySortingBar title={title} />
  }

  return (
    <>
      <StyledSticky
        experimentalNative
        disableResizing
        defaultOffsetTop={isScrollingUp ? stickyOffsetTop - 2 : -65}
      >
        {({ isSticky }) => (
          <StickyWrapper
            data-testid="ProductStreamHeader"
            style={isScrollingUp && isSticky ? hiddenSortingStyles : undefined}
          >
            <CategorySortingBar title={title} />
          </StickyWrapper>
        )}
      </StyledSticky>
      {subHeader}
    </>
  )
}

export default React.memo(ProductStreamHeader)
